import {React,useState} from "react"
import { Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import clogo from "../assets/clogo.png"
import useSound from 'use-sound';
import sfx from '../assets/click.mp3';

const Header = ({img})=>{

    const [play] = useSound(sfx);
    const[isOpen, setIsOpen] = useState(false)

    const toggle = ()=>{setIsOpen(!isOpen)}

    return(
        <Navbar dark expand="md" color="faded">
        {(img)?(<NavbarBrand href="/" className="mr-auto mt-2 ml-1 cit"><img src={img} alt="cit-logo" height="70rem"></img></NavbarBrand>)
        :(<NavbarBrand href="/" className="mr-auto cit"><img src={clogo} alt="cit-logo" height="60rem"></img></NavbarBrand>)}
        <NavbarToggler onClick={()=>{toggle();play()}} className="mr-2"/>
        <Collapse isOpen={isOpen} navbar>
          <Nav navbar>
          <NavItem>
                <NavLink onClick={()=>{toggle();play()}} tag={Link} to="/online">Online Events</NavLink>
            </NavItem>
            <NavItem>
                <NavLink onClick={()=>{toggle();play()}} tag={Link} to="/live">Live Events</NavLink>
            </NavItem>
            <NavItem>
                <NavLink onClick={()=>{toggle();play()}} tag={Link} to="/about">About</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    )
}

export default Header;